/**
 * ISO alpha-2 → regional indicator flag emoji (display only, not stored).
 */
export function countryCodeToFlagEmoji(countryCode) {
  if (!countryCode || countryCode.length !== 2) {
    return '';
  }

  return [...countryCode.toUpperCase()]
    .map((char) => 0x1F1E6 + char.charCodeAt(0) - 65)
    .map((codePoint) => String.fromCodePoint(codePoint))
    .join('');
}

export function formatCountryOptionLabel(country) {
  if (!country) {
    return '';
  }

  const flag = countryCodeToFlagEmoji(country.code);
  const name = country.name || country.code;
  const phone = country.phone_code || '';

  return phone ? `${flag} ${name} (${phone})` : `${flag} ${name}`;
}

export function formatPhonePrefixLabel(country) {
  if (!country) {
    return '';
  }

  return `${countryCodeToFlagEmoji(country.code)} ${country.phone_code || ''}`.trim();
}

export function countryMatchesSearch(country, query) {
  if (!query) {
    return true;
  }

  const normalized = query.trim().toLowerCase();
  const phoneDigits = (country.phone_code || '').replace(/\D/g, '');

  return (
    (country.code || '').toLowerCase().includes(normalized)
    || (country.name || '').toLowerCase().includes(normalized)
    || phoneDigits.includes(normalized.replace(/\D/g, ''))
    || (country.phone_code || '').toLowerCase().includes(normalized)
  );
}

export function filterCountriesForSearch(countries, query) {
  if (!query?.trim()) {
    return countries;
  }

  return countries.filter((country) => countryMatchesSearch(country, query));
}

export function resolvePhonePrefixCountryCode(countries, countryCode, phoneCountryCode) {
  const list = countries || [];
  const matchingSelected = list.find(
    (country) => country.code === countryCode && country.phone_code === phoneCountryCode,
  );
  if (matchingSelected) {
    return matchingSelected.code;
  }

  const matchingPhone = list.find((country) => country.phone_code === phoneCountryCode);
  return matchingPhone?.code || countryCode;
}
